import { calculateDatesBetween, formatDate, getStudentsInThisClass } from "../components/common/Helpers";

const baseUrl = process.env.NODE_ENV === "production"
  ? "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/"
  : "http://localhost:3001/";

async function getSchoolClass(id) {
  const response = await fetch(`${baseUrl}classes/${id}`);
  if (response.ok) return response.json();
  throw response;
}

async function getSchoolClasses() {
  const response = await fetch(`${baseUrl}classes`);
  if (response.ok) return response.json();
  throw response;
}

async function saveSchoolClass(schoolClass) {
  const response = await fetch(`${baseUrl}classes/${schoolClass.id || ""}`, {
    method: schoolClass.id ? "PUT" : "POST", // POST for create, PUT to update when id already exists.
    headers: { "content-type": "application/json" },
    body: JSON.stringify(schoolClass),
  });
  if (response.ok) return response.json();
  throw response;
}


async function getClassStudents() {
  const response = await fetch(`${baseUrl}classstudents`);
  if (response.ok) return response.json();
  throw response;
}

async function saveClassStudent(classStudent) {
  const response = await fetch(`${baseUrl}classstudents`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(classStudent),
  });
  if (response.ok) return response.json();
  throw response;
}

async function deleteClassStudent(classStudent) {
  // Use 'id' as primary key for json-server, not 'nid'
  const id = classStudent.id || classStudent.nid;
  const response = await fetch(`${baseUrl}classstudents/${id}`, {
    method: "DELETE",
    headers: { "content-type": "application/json" },
  });
  if (response.ok) return response.json();
  throw response;
}


const createLessonObject = (
  id,
  index,
  date,
  startTime,
  teacherId,
  dayOfWeek,
  classTypeId,
  isRecurring,
  students,
  classStudents,
) => ({
  id: `${id}-${index}`,
  defaultLessonDetails: {
    date: date instanceof Date ? formatDate(date) : date,
    dayOfWeek,
    startTime,
    teacherId,
    classTypeId,
    isRecurring,
    comment: "",
  },
  defaultStudents: getStudentsInThisClass(students, classStudents, id),
});

const findLessonRegister = (lessonRegister, lessonId) => lessonRegister.find(lr => lr.lessonId === lessonId) || null;

function generateScheduledClasses(
  schoolClass,
  lessonRegister,
  students,
  classStudents,
) {
  const {
    id,
    startTime,
    teacherId,
    dayOfWeek,
    isRecurring,
    fromDate,
    tillDate,
    classTypeId,
  } = schoolClass;

  if (!dayOfWeek || !fromDate) {
    return [];
  }

  const dates = isRecurring && tillDate
    ? calculateDatesBetween(fromDate, tillDate, dayOfWeek)
    : [fromDate];

  return dates.map((date, index) => {
    const lesson = createLessonObject(
      id,
      index,
      date,
      startTime,
      teacherId,
      dayOfWeek,
      classTypeId,
      isRecurring,
      students,
      classStudents,
    );

    const lessonRegisterForLesson = findLessonRegister(lessonRegister, lesson.id);
    return {
      ...lesson,
      lessonRegister: lessonRegisterForLesson,
    };
  });
}


export default {
  getSchoolClass,
  getSchoolClasses,
  saveSchoolClass,
  getClassStudents,
  saveClassStudent,
  deleteClassStudent,
  generateScheduledClasses,
};
